import { type Enum } from '@webapp/infrastructure/types/Enum'

// Section grouping for the PO PDF label editor (Angular LABEL_SECTION_MAP).
export const PDFLabelSections = {
  PO_FIELDS: 'po-fields',
  PO_COSTS: 'po-costs',
  ITEM_FIELDS: 'item-fields',
} as const

export type PDFLabelSectionEnum = Enum<typeof PDFLabelSections>
